/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { ClosedEnum } from "../types/enums.js";

/**
 * An enumeration.
 */
export const AppSchemasLedgersTokenType = {
  Ckerc20Mainnet: "ckerc20_mainnet",
  Ckerc20Sepolia: "ckerc20_sepolia",
  Sns: "sns",
  Tcycles: "tcycles",
} as const;
/**
 * An enumeration.
 */
export type AppSchemasLedgersTokenType = ClosedEnum<
  typeof AppSchemasLedgersTokenType
>;

/** @internal */
export const AppSchemasLedgersTokenType$inboundSchema: z.ZodNativeEnum<
  typeof AppSchemasLedgersTokenType
> = z.nativeEnum(AppSchemasLedgersTokenType);

/** @internal */
export const AppSchemasLedgersTokenType$outboundSchema: z.ZodNativeEnum<
  typeof AppSchemasLedgersTokenType
> = AppSchemasLedgersTokenType$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace AppSchemasLedgersTokenType$ {
  /** @deprecated use `AppSchemasLedgersTokenType$inboundSchema` instead. */
  export const inboundSchema = AppSchemasLedgersTokenType$inboundSchema;
  /** @deprecated use `AppSchemasLedgersTokenType$outboundSchema` instead. */
  export const outboundSchema = AppSchemasLedgersTokenType$outboundSchema;
}
